import * as postMoreStoriesActions from '../../action_creators/post/post_more_stories_action_creators';
import PostMoreStoriesModel from '../../../models/post/post_more_stories_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postMoreStoriesActions.postMoreStoriesLoading({}, store));
    return PostMoreStoriesModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(
          postMoreStoriesActions.postMoreStoriesLoaded(resp.data, store)
        );
      })
      .catch(function handleUserError(err) {
        dispatch(postMoreStoriesActions.postMoreStoriesLoadError(err, store));
        log.error(
          err,
          `Error in post see more actions, message: ${err.message}`
        );
      });
  };
}
